<template>
  <table>
    <thead>
      <tr class="invoice-cost-tr">
        <th scope="col">Name</th>
        <th scope="col">Cost per unit</th>
        <th scope="col">Quantity</th>
        <th class="align-right" scope="col">Total cost</th>
        <th class="align-right" scope="col" width="2%"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(lineItem, index) in totalSelectedLineItems"
        :key="`staff-hour-${lineItem.id}-${index}`"
      >
        <td v-if="lineItem.label?.length > 15">
          <NrTooltip :label="lineItem.label">
            {{ truncate(lineItem.label, { length: 15 }) }}
          </NrTooltip>
        </td>
        <td v-else>
          {{ lineItem.label }}
        </td>
        <td>{{ formatCost(lineItem.cost, 4) || '$0.00' }}</td>
        <td>{{ lineItem.total_count }}</td>
        <td class="align-right">
          {{ formatCost(lineItem.total_cost) }}
        </td>
        <td>
          <InvoiceItemMenu
            @on-edit="onEdit(lineItem, index)"
            @on-delete="onDelete(lineItem)"
          />
        </td>
      </tr>
    </tbody>
  </table>
  <NrModal
    :show="activeItemDeleteModal"
    primaryButtonText="Delete item"
    secondaryButtonText="Cancel"
    title="Delete line item"
    hasSecondaryButton
    @on-primary-click="deleteInvoiceLineItem"
    @on-secondary-click="setActiveModal('')"
    @on-close-click="setActiveModal('')"
  >
    <p>
      Are you sure you want to remove
      {{ this.invoiceItemToEdit?.label }} from the list?
    </p>
  </NrModal>
</template>
<script lang="ts">
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import NrModal from '@nextrequestco/components/src/components/NrModal'
import InvoiceItemMenu from './InvoiceItemMenu.vue'
import { mapMutations, mapState, mapActions } from 'vuex'
import { SelectedLineItemOption } from '../types/invoice_line_items'
import truncate from 'lodash/truncate'
import helpers from '../../../../../utils/helpers.js'

export default {
  components: {
    NrTooltip,
    NrModal,
    InvoiceItemMenu
  },

  computed: {
    ...mapState('request_show', [
      'totalSelectedLineItems',
      'activeModal',
      'invoiceItemToEdit'
    ]),

    activeItemDeleteModal() {
      return this.activeModal === 'deleteInvoiceItem'
    }
  },

  methods: {
    ...mapActions('request_show', ['recalculateAllCosts']),

    ...mapMutations('request_show', [
      'setInvoiceLineItemType',
      'setInvoiceSelectedLineItem',
      'setInvoiceLineItemQuantity',
      'setInvoiceSelectedSurchargeItem',
      'setInvoiceAddItemModal',
      'setTotalSelectedLineItems',
      'setInvoiceItemToEdit',
      'setActiveModal'
    ]),

    truncate,

    formatCost(amount: number, maximumFractionDigits: number = 2) {
      return helpers.formatCost(amount, maximumFractionDigits)
    },

    onEdit(item: SelectedLineItemOption, index: number): void {
      const lineItem = { ...item, index }
      this.setInvoiceItemToEdit(lineItem)
      this.setInvoiceLineItemType('Line item')
      this.setInvoiceSelectedLineItem(item)
      this.setInvoiceLineItemQuantity(item.total_count)
      this.setInvoiceAddItemModal(true)
    },

    deleteInvoiceLineItem(): void {
      const newLineItems = this.totalSelectedLineItems.filter(
        (i: SelectedLineItemOption) => i.value !== this.invoiceItemToEdit?.value
      )
      this.setTotalSelectedLineItems(newLineItems)
      this.recalculateAllCosts()
      this.setActiveModal('')
    },

    onDelete(item: SelectedLineItemOption): void {
      this.setInvoiceItemToEdit(item)
      this.setActiveModal('deleteInvoiceItem')
    }
  }
}
</script>
<style lang="scss"></style>
